if (!customElements.get('gallery-thumbs')) {
  customElements.define(
    'gallery-thumbs',
    class GalleryThumbs extends HTMLElement {
      connectedCallback() {
        this.slideshow = document.getElementById(this.dataset.slideshow);
        this.list = this.querySelector('[data-thumbs-track]');
        if (!this.slideshow || !this.list) return;

        this.slider = this.slideshow.querySelector('.slider--generic');
        this.thumbs = Array.from(this.querySelectorAll('[data-thumbnail]'));
        this.slides = Array.from(this.slideshow.querySelectorAll('.slideshow__slide'));
        if (!this.slider || this.slides.length < 2) return;

        var self = this;
        this.lastNav = 0;

        this.thumbs.forEach(function (thumb, index) {
          thumb.addEventListener('click', function (event) {
            event.preventDefault();
            self.goTo(index);
          });
        });

        this.slider.addEventListener('scroll', function () {
          if (self.throttle) return;
          self.throttle = setTimeout(function () {
            self.throttle = null;
            self.setActive(self.indexFromScroll());
          }, 60);
        });

        this.observer = new MutationObserver(function () {
          if (Date.now() - self.lastNav < 900) return;
          var shown = self.slides.findIndex(function (slide) {
            return slide.getAttribute('aria-hidden') === 'false';
          });
          if (shown > -1 && shown !== self.indexFromScroll()) self.goTo(shown);
        });
        this.slides.forEach(function (slide) {
          self.observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
        });

        this.setActive(this.indexFromScroll());
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.throttle) clearTimeout(this.throttle);
      }

      indexFromScroll() {
        var width = this.slider.clientWidth || 1;
        var index = Math.round(this.slider.scrollLeft / width);
        return Math.max(0, Math.min(index, this.slides.length - 1));
      }

      goTo(index) {
        var slider = this.slider;
        var target = this.slides[index].offsetLeft;
        var start = slider.scrollLeft;
        this.lastNav = Date.now();
        slider.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(function () {
          if (slider.scrollLeft === start && Math.abs(target - start) > 4) {
            slider.scrollTo({ left: target, behavior: 'instant' });
          }
        }, 150);
        this.setActive(index);
      }

      setActive(index) {
        var list = this.list;
        this.thumbs.forEach(function (thumb, i) {
          if (i === index) {
            thumb.setAttribute('aria-pressed', 'true');
            var item = thumb.parentElement;
            var max = list.scrollWidth - list.clientWidth;
            if (max > 0) {
              var left = item.offsetLeft - list.clientWidth / 2 + item.clientWidth / 2;
              list.scrollTo({ left: Math.max(0, Math.min(left, max)), behavior: 'smooth' });
            }
          } else {
            thumb.removeAttribute('aria-pressed');
          }
        });
      }
    }
  );
}